module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }